import * as PIXI from 'pixi.js'
import TWEEN from '@tweenjs/tween.js'

import Node from './entity-node'
// import * as debounce from 'lodash.debounce'

// import config from './config'

class NodeSystem {
  /// //////////////////////////////////////////////
  // NODES
  /// ////////////////
  constructor (game) {
    this.game = game
    // From server msg
    // this.nodeUpdate = debounce(this.nodeUpdate, 100)
    this.start()
  }
  start () {
    this.nodeMap = new Map()
  }
  forEach (fn) {
    this.nodeMap.forEach(fn)
  }
  surroundingForEach (pos, fn) {
    [
      this.nodeGet(pos.x - 1, pos.y - 1),
      this.nodeGet(pos.x, pos.y - 1),
      this.nodeGet(pos.x + 1, pos.y - 1),

      this.nodeGet(pos.x - 1, pos.y),
      this.nodeGet(pos.x, pos.y), // Remove this if no self node
      this.nodeGet(pos.x + 1, pos.y),

      this.nodeGet(pos.x - 1, pos.y + 1),
      this.nodeGet(pos.x, pos.y + 1),
      this.nodeGet(pos.x + 1, pos.y + 1)
    ].some(fn)
  }
  nodeGet (x, y) {
    return this.nodeMap.get(x + '|' + y)
  }
  nodeUpdate (state) {
    // Update node state, indexes, etc
    const node = this.nodeMap.get(state.id)
    if (!node) {
      return
    }
    node.set(state)
  }
  nodeAddChar (m, isClient) {
    const node = this.nodeMap.get(m.node.id)
    if (!node) return

    node.set(m.node)

    const player = this.game.players.playerGet(m.fromPlayer)
    if (!player) return
    // this is not a problem and we still need it somehow?
    // XXX: Experimental smooth, incoming server side
    if (this.game.config.clientSync && player.state.id === this.game.ID && !isClient) {
      const to = node._sync.get('match')
      clearTimeout(to) // Reset sync checker
      node._sync.set('match', setTimeout(() => {
        // const n = this.nodeMap.get(m.node.id) // Reload node
        node.match = node.state.playerMatch[this.game.ID]
        node.set(node.state)
      }, this.game.config.syncTimeout))
      return
    }

    // if the player doesn't have graphics yet don't bother shooting things
    if (!player) {
      return
    }
    if (this.game.renderer.offScreen(node.pixiObj, 200)) {
      return
    }

    // Only shoot if it is client?
    const dstPos = { x: node.pixiObj.x, y: node.pixiObj.y, alpha: 0.4 }
    const srcPos = { x: player.pixiObj.x, y: player.pixiObj.y + 30, alpha: 1 }
    // Text Bullet
    const gr = new PIXI.Text(m.ch, {
      fontSize: 30,
      fill: 'white',
      stroke: player.state.color,
      strokeThickness: 3,
      dropShadow: true,
      dropShadowColor: player.state.color,
      dropShadowDistance: 0,
      dropShadowBlur: 2
    })
    gr.anchor.set(0.5, 0.5)
    gr.x = srcPos.x
    gr.y = srcPos.y

    // Add the effect to the effect layer
    this.game.renderer.pixi.effects.addChild(gr)
    new TWEEN.Tween(srcPos)
      .to(dstPos, this.game.config.animSpeed - 100)
      .onUpdate(() => {
        gr.x = srcPos.x
        gr.y = srcPos.y
        gr.alpha = srcPos.alpha
      })
      .onComplete(() => {
        gr.destroy({ children: true, texture: true })
      })
      .start()
  }

  // Dont do this now just update the shunk
  chunkUpdate (state) {
    this.game.renderer.pixi.nodes.removeChildren()
    this.game.renderer.pixi.text.removeChildren()
    const oldMap = this.nodeMap
    this.nodeMap = new Map()
    for (let i = 0, len = state.nodes.length; i < len; i++) {
      const info = state.nodes[i]
      if (!info) continue
      // Check if chunk exists locally
      // and load local State
      // update Node somehow?
      let lnode = oldMap.get(info.id)
      if (!lnode) { // we update the node data internally
        lnode = new Node(this.game, info)
      }
      // remove old node from list we should clean this later
      oldMap.delete(info.id)
      this.nodeMap.set(info.id, lnode) // Read

      // Re add nodes
      this.game.renderer.pixi.nodes.addChild(lnode.pixiObj)
      this.game.renderer.pixi.text.addChild(lnode.textObj)
    }
    // for (let k of oldMap) { oldMap[k].destroy() }
    oldMap.forEach(v => v.destroy())

    // Why? need to have all nodes before update update
    for (let i = 0, len = state.nodes.length; i < len; i++) {
      const info = state.nodes[i]
      if (!info) continue
      this.nodeUpdate(info)
    }
  }
  nodeRender (delta) {
    /// //////////////////////////////////////////////////////
    // Redraw the linkMap
    /// /
    this.game.renderer.pixi.tracking.nodes.clear()
    this.game.renderer.pixi.linkMap.clear()

    /* for (let k in this.nodeMap) {
      if (!this.nodeMap[k]) continue
      this.nodeMap[k].update(delta)
    } */

    this.nodeMap.forEach(v => v && v.update(delta))
  }
}

export default NodeSystem
